
    export enum EnumLocHeaderOption {
			Company = 0,
			CompanyPlant = 1,
			Plant = 2,
			DistributorOnly = 3,
    }